import type { SecretView } from "../api/types";
import { grouped, since } from "./format";

/** What each secret is called on screen, and what it is for. */
export const SECRETS: Record<string, { label: string; help: string }> = {
  quarryCookie: {
    label: "Quarry session cookie",
    help: "Only the query's owner may rerun a Quarry query, so the two rerun sources send their session. It lapses every few weeks; paste a new one here rather than redeploying.",
  },
};

/** What a secret is called, falling back to its own name for one this screen has not been told about. */
export function secretLabel(name: string): string {
  return SECRETS[name]?.label ?? name;
}

/**
 * What a secret holds, in words, without saying it.
 *
 * The length is there to catch the usual mistake, which is pasting half of one: a cookie that reads as
 * forty characters when the last one was four hundred is wrong before any run proves it.
 *
 * @param secret what the server said about it.
 * @param at what time it is, for how long ago it was set.
 */
export function secretWords(secret: SecretView, at: number): string {
  const length = `${grouped(secret.length ?? 0)} characters`;

  if (!secret.set) {
    return secret.variable
      ? `not set, and ${secret.variable} is empty too`
      : "not set";
  }

  if (secret.fromEnvironment) {
    return `from ${secret.variable ?? "the environment"}, ${length}`;
  }

  return secret.setAt
    ? `set here ${since(secret.setAt, at)}, ${length}`
    : `set here, ${length}`;
}
